// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import StyledPicker from "./StyledPicker-APP_CLIENT.styled";

export default StyledPicker;
